const wizard = [
    {
        selector: '[data-wizard=""]',
        path: { filename: 'wizard' },
    },
];

export { wizard };
